module.exports = __webpack_public_path__ + "static/Firewatch6-f2b44a7919c3bf93b42739e17f75f9f8.webp";